import axios from 'axios';

import urls from '@/urls';
import { isEmailValid } from '@/utils';

export type SsoEmailLookupMatchType = {
  ssoConfigId: string;
  organizationName: string;
};

export async function lookupSsoByEmail(
  email: string,
): Promise<SsoEmailLookupMatchType | null> {
  if (!email || !isEmailValid(email)) return null;

  try {
    const response = await axios.post(urls.sso.lookup_by_email, { email });
    const ssoConfigId: string | undefined = response.data?.sso_config_id;
    const organizationName: string | undefined =
      response.data?.organization_name;
    if (!ssoConfigId || !organizationName) return null;
    return { ssoConfigId, organizationName };
  } catch {
    return null;
  }
}
